import { trustFeatures } from '@/mocks/home';

export default function SecuritySection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            安全可靠，值得信赖
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            多重安全防护体系，为您的账户和资金保驾护航
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {trustFeatures.map((item, index) => (
            <div key={index} className="text-center p-6">
              <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-accent-100 text-accent-600 mx-auto mb-4">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="text-base font-bold font-heading text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}